/**
 * @format
 */
import { FileService } from '@/scripts/services/file/file-service';
export class FileByteSizeLimitError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FileByteSizeLimitError';
    }
}

export class FileTypeError extends Error {
    constructor(message) {
        super(message);
        this.name = 'FileTypeError';
    }
}

export default {
    methods: {
        getFileFromSource(sourceEvent) {
            if (sourceEvent.currentTarget.files) {
                return sourceEvent.currentTarget.files[0];
            } else if (sourceEvent.dataTransfer) {
                return sourceEvent.dataTransfer.files[0];
            } else if (sourceEvent) {
                if (sourceEvent.dataTransfer) {
                    return sourceEvent.dataTransfer.files[0];
                } else if (sourceEvent.target.files) {
                    return sourceEvent.target.files[0];
                }
            }
            return null;
        },

        getBase64Url(
            sourceEvent,
            { byteSizeLimit = Number.MAX_SAFE_INTEGER, allowedFileTypes = [], isEditable = false },
        ) {
            return new Promise((resolve, reject) => {
                const uploadedFile = this.getFileFromSource(sourceEvent);

                if (uploadedFile) {
                    if (
                        uploadedFile.size <= byteSizeLimit &&
                        (!allowedFileTypes.length ||
                            (allowedFileTypes.length > 0 &&
                                ((!isEditable && allowedFileTypes.includes(uploadedFile.type)) ||
                                    (isEditable &&
                                        allowedFileTypes.includes(
                                            uploadedFile.type.slice(
                                                uploadedFile.type.indexOf('/') + 1,
                                            ),
                                        )))))
                    ) {
                        this.$helpers
                            .getBase64Encoding(uploadedFile)
                            .then((encodingStr) => {
                                resolve({
                                    encodingStr,
                                    name: uploadedFile.name,
                                    size: uploadedFile.size,
                                    type: uploadedFile.type,
                                });
                            })
                            .catch(reject);
                    } else {
                        if (uploadedFile.size > byteSizeLimit) {
                            reject(
                                new FileByteSizeLimitError(
                                    `Given file size is ${uploadedFile.size}`,
                                ),
                            );
                        } else {
                            reject(new FileTypeError(`Give file type is ${uploadedFile.type}`));
                        }
                    }
                }
            });
        },

        getBase64UrlSingle(
            file,
            {
                byteSizeMinimum = 0,
                byteSizeLimit = Number.MAX_SAFE_INTEGER,
                allowedImageTypes = [],
            },
        ) {
            return new Promise((resolve, reject) => {
                if (file) {
                    if (
                        file.size > byteSizeMinimum &&
                        file.size <= byteSizeLimit &&
                        allowedImageTypes.length > 0 &&
                        allowedImageTypes.includes(file.type)
                    ) {
                        this.$helpers
                            .getBase64Encoding(file)
                            .then((encodingStr) =>
                                resolve({ encodingStr, name: file.name, type: file.type }),
                            )
                            .catch(reject);
                    } else {
                        if (file.size > byteSizeLimit) {
                            reject(new FileByteSizeLimitError(`Given file size is ${file.size}`));
                        } else {
                            reject(new FileTypeError(`Give file type is ${file.type}`));
                        }
                    }
                }
            });
        },

        isBase64(url) {
            const base64RegExp = /data:(video|image)[^;]+;base64[^"]+/;
            return url.match(base64RegExp);
        },

        handleUploadMixin(e, fileConfig) {
            return new Promise((resolve, reject) => {
                this.getBase64Url(e, fileConfig)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        if (error instanceof FileByteSizeLimitError) {
                            this.$helpers.showFailNotification(
                                `File size exceeds the maximum amount of ${this.$helpers.convertbytesToLargestUnit(fileConfig.byteSizeLimit)}`,
                            );
                        } else if (error instanceof FileTypeError) {
                            const [head, ...tail] = this.fileConfig.fileSelectorAllowedTypes;
                            this.$helpers.showFailNotification(
                                `File needs to be of type ${tail.join(', ')} or ${head}`,
                            );
                        } else {
                            this.$helpers.showFailNotification(
                                'An error occurred while uploading your image. Please check your format and try again.',
                            );
                        }
                        reject();
                    });
            });
        },

        mediaImageRequestMixin(element, name) {
            return new Promise((resolve, reject) => {
                const file = {
                    name: name,
                    url: element.encodingStr,
                };

                FileService.post(file)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch(() => {
                        this.$helpers.showFailNotification('Error trying to save Image');
                        reject();
                    });
            });
        },
    },
};
